import { Component, ElementRef, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ModalService } from './modal.service';

// based on and adapted from https://jasonwatmore.com/post/2020/09/24/angular-10-custom-modal-window-dialog-box
@Component({
    selector: 'jw-modal',
    templateUrl: 'modal.component.html',
    styleUrls: ['modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ModalComponent implements OnInit, OnDestroy {
    private element: any;
    @Input() id: string;
    @Input() headerText: string;
    @Input() showCloseButton = true;

    constructor(private modalService: ModalService, private el: ElementRef) {
        this.element = el.nativeElement;
        this.element.style.display = 'none'; // hidden by default
    }

    ngOnInit(): void {
        // ensure id attribute exists
        if (!this.id) {
            console.error('custom modal must have an id');
            return;
        }

        // move element to bottom of page (just before </body>) so it can be displayed above everything else
        document.body.appendChild(this.element);

        // close modal on background click
        /*this.element.addEventListener('click', el => {            
            if (el.target.className === 'jw-modal-background') {
                this.close();
            }
        });*/

        // add self (this modal instance) to the modal service so it's accessible from controllers
        this.modalService.add(this);
    }

    // remove self from modal service when component is destroyed
    ngOnDestroy(): void {
        this.modalService.remove(this.id);
        this.element.remove();
    }

    // open modal
    open(): void {
        console.log(this.element);
        this.element.style.display = 'block';
        document.body.classList.add('jw-modal-open');
    }

    // close modal
    close(): void {
        this.element.style.display = 'none';
        document.body.classList.remove('jw-modal-open');
    }
}
